// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { DeviceGroupSupervisoryStatusContent, unionToDeviceGroupSupervisoryStatusContent, unionListToDeviceGroupSupervisoryStatusContent } from './device-group-supervisory-status-content';
import { ElevatorGroupSupervisoryStatusMessage, ElevatorGroupSupervisoryStatusMessageT } from './elevator-group-supervisory-status-message';
import { EscalatorGroupSupervisoryStatusMessage, EscalatorGroupSupervisoryStatusMessageT } from './escalator-group-supervisory-status-message';


export class GroupSupervisoryStatusMessage implements flatbuffers.IUnpackableObject<GroupSupervisoryStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):GroupSupervisoryStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsGroupSupervisoryStatusMessage(bb:flatbuffers.ByteBuffer, obj?:GroupSupervisoryStatusMessage):GroupSupervisoryStatusMessage {
  return (obj || new GroupSupervisoryStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsGroupSupervisoryStatusMessage(bb:flatbuffers.ByteBuffer, obj?:GroupSupervisoryStatusMessage):GroupSupervisoryStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new GroupSupervisoryStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

messageType():DeviceGroupSupervisoryStatusContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceGroupSupervisoryStatusContent.NONE;
}

message<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startGroupSupervisoryStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessageType(builder:flatbuffers.Builder, messageType:DeviceGroupSupervisoryStatusContent) {
  builder.addFieldInt8(0, messageType, DeviceGroupSupervisoryStatusContent.NONE);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
}

static endGroupSupervisoryStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // message
  return offset;
}

static createGroupSupervisoryStatusMessage(builder:flatbuffers.Builder, messageType:DeviceGroupSupervisoryStatusContent, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  GroupSupervisoryStatusMessage.startGroupSupervisoryStatusMessage(builder);
  GroupSupervisoryStatusMessage.addMessageType(builder, messageType);
  GroupSupervisoryStatusMessage.addMessage(builder, messageOffset);
  return GroupSupervisoryStatusMessage.endGroupSupervisoryStatusMessage(builder);
}

unpack(): GroupSupervisoryStatusMessageT {
  return new GroupSupervisoryStatusMessageT(
    this.messageType(),
    (() => {
      const temp = unionToDeviceGroupSupervisoryStatusContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: GroupSupervisoryStatusMessageT): void {
  _o.messageType = this.messageType();
  _o.message = (() => {
      const temp = unionToDeviceGroupSupervisoryStatusContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class GroupSupervisoryStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public messageType: DeviceGroupSupervisoryStatusContent = DeviceGroupSupervisoryStatusContent.NONE,
  public message: ElevatorGroupSupervisoryStatusMessageT|EscalatorGroupSupervisoryStatusMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const message = builder.createObjectOffset(this.message);

  return GroupSupervisoryStatusMessage.createGroupSupervisoryStatusMessage(builder,
    this.messageType,
    message
  );
}
}
